import React from 'react'
import {createSvgIcon} from "@mui/material"

export default createSvgIcon(
    <svg className="collapsed-icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="m 7.4 3.4 c -0.3 0.3 -0.3 0.8 0 1.1 l 7 7 l -7 7 c -0.3 0.3 -0.3 0.8 0 1.1 c 0.3 0.3 0.8 0.3 1.1 -0 l 7.5 -7.5 c 0.1 -0.1 0.2 -0.3 0.2 -0.6 s -0.1 -0.4 -0.2 -0.6 l -7.5 -7.5 c -0.3 -0.3 -0.8 -0.3 -1.1 0 z"></path>
    </svg>, "collapsed"
)
